import Tone from 'tone';
import Notes from 'midi/Notes.js';
import Voice from './Voice.js';

export default superclass => class extends superclass  {
    voiceCounter = 0;
    voiceToTranspose = {};
    frequencyToVoice = {};
    voiceToFrequency = {};
    voicesUsed = [];
    numberToVoice = {};

    useVoice(note, time) {
        return this.buildVoice(this.findFreeVoice(time, note));
    }

    buildVoice(voiceNumber) {
        return new Voice(
            this.carrierOscillator.voices[voiceNumber],
            this.modulatorOscillators.map(
                osc => osc.voices[voiceNumber]),
            voiceNumber);
    }

    findFreeVoice(time=Tone.Master.context.currentTime, note) {
        let noteName = Notes.fromTranspose(note).toString();
        // first see if theres a voice with that frequency playing
        let freq = this.oscillators[0].getNoteFromTranspose(note).toFrequency();
        for (let voice in this.voiceToFrequency) {
            if (parseInt(voice) >= this.polyphonyParameter.get()) {
                continue;
            }
            let voiceFreq = this.voiceToFrequency[voice];
            if (voiceFreq === freq) {
                // there is a voice that last played this frequency,
                // so we use it! easy peasy!
                return parseInt(voice);
            }
        }

        // otherwise lets then find a voice that has an envelope of 0
        // meaning it isn't being used
        let voices = this.oscillators[0].voices;
        let _c = this.voiceCounter;
        for (let i=0; i < this.polyphonyParameter.get(); i++) {
            let num = (_c + i) % voices.length;
            let envValue = this.forSlot(num)[0].envelope.getValueAtTime(time);
            if (envValue === 0) {
                return parseInt(num);
            }
        }

        // otherwise we find the voice we haven't used in the longest time
        let _voices = [];
        for (let i=this.voicesUsed.length -1; i >= 0; i--) {
            _voices = Array.from(new Set([... _voices, this.voicesUsed[i]]));
            if (_voices.length === this.polyphonyParameter.get()) {
                return this.voicesUsed[i];
            }
        }
        return this.polyphonyParameter.get() - 1;
    }

    // Keeps track of what voice is using which frequency
    storeVoiceFrequency(note, voiceCounter, voice) {
        let freq = this.oscillators[0].getNoteFromTranspose(note);
        this.frequencyToVoice[freq.toFrequency()] = voiceCounter;
        this.voiceToFrequency[voiceCounter] = freq.toFrequency();
        this.voiceCounter = (this.voiceCounter + 1) % this.polyphonyParameter.get();
        this.numberToVoice[voiceCounter] = voice;
    }

    clearVoiceData() {
        this.releaseAll();
        this.voiceCounter = 0;
        this.voiceToTranspose = {};
        this.frequencyToVoice = {};
        this.voiceToFrequency = {};
        this.voicesUsed = [];
        this.numberToVoice = {};
    }
}
